export const ConstantsUtil = {
    WC_NAME_SUFFIX: '.wcn.id',
    WC_NAMES_ALLOWED_DOMAINS: ['walletconnect.com'],
    BLOCKCHAIN_API_RPC_URL: 'https://rpc.walletconnect.org',
    PULSE_API_URL: 'https://pulse.walletconnect.org',
    W3M_API_URL: 'https://api.web3modal.org'
};
//# sourceMappingURL=ConstantsUtil.js.map